module.exports = __webpack_public_path__ + "static/media/empty-info.dbce53e8.png";